import { mediaUrl } from '@/lib/mediaUrl';
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { toast } from 'sonner';
import { Check } from 'lucide-react';

const CaseStudyElement = ({ config, element, onComplete, onSaveData, isCompleted, progress }) => {
  const saved = progress?.element_progress?.[element.id] || {};
  const [reflections, setReflections] = useState(saved.reflections || {});
  const handleSave = () => { onSaveData({ reflections }); if (!isCompleted) onComplete(); toast.success('Reflections saved'); };
  return (
    <div className="space-y-6">
      {config.title && <h3 className="text-lg font-semibold text-slate-800">{config.title}</h3>}
      {config.scenario_text && <div className="p-5 bg-[#f8fafc] rounded-xl text-slate-800 leading-relaxed">{config.scenario_text}</div>}
      {config.scenario_image_url && <img src={mediaUrl(config.scenario_image_url)} alt={config.scenario_image_alt || ""} className="rounded-xl max-h-64 object-contain" />}
      {(config.reflective_questions || []).length > 0 && (
        <div className="space-y-4">
          <h4 className="font-semibold text-slate-800">Reflective Questions</h4>
          {config.reflective_questions.map((q, i) => (
            <div key={`q-${i}-${q.slice(0,20)}`} className="space-y-2">
              <p className="text-sm font-medium text-slate-700">{i + 1}. {q}</p>
              <Textarea value={reflections[i] || ''} onChange={(e) => setReflections(prev => ({ ...prev, [i]: e.target.value }))} placeholder="Write your reflection..." rows={3} />
            </div>
          ))}
        </div>
      )}
      <Button onClick={handleSave} className="bg-[#20acf6] hover:bg-[#3bb8f7]" data-testid="save-case-study-btn"><Check className="h-4 w-4 mr-2" /> {isCompleted ? 'Update' : 'Save & Complete'}</Button>
    </div>
  );
};

export default CaseStudyElement;
